import GameQualifyModal from './GameQualifyModal';
export default GameQualifyModal;
